import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TrendArrowupIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M7 13.3862H17V23.3862L15.2036 23.3563L15.2186 16.3952L7.61377 24L6.38623 22.7724L13.991 15.1676L7 15.1527L7 13.3862Z'
                fill='currentColor'
            />
        </>
    ),
})

TrendArrowupIcon.displayName = 'TrendArrowupIcon'
